export default __webpack_public_path__ + "static/media/Ballroll_00080.94f7c1dc.png";